import { __rest } from "tslib";
export function createElement(tagName, attributes = {}) {
    const el = document.createElement(tagName);
    const { className } = attributes, attrs = __rest(attributes, ["className"]);
    if (className) {
        className.split(' ').forEach(className => el.classList.add(className));
    }
    Object.keys(attrs).forEach(name => {
        el.setAttribute(name, attributes[name]);
    });
    return el;
}
function getTargetByEvent(event) {
    return /scroll|resize/.test(event) ? window : document;
}
export function removeEventListener(event, handler) {
    const target = getTargetByEvent(event);
    target.removeEventListener(event, handler);
}
export function addEventListener(event, handler) {
    const target = getTargetByEvent(event);
    target.addEventListener(event, handler);
    return () => removeEventListener(event, handler);
}
export function getWindowSize() {
    return {
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
export function getElementSize(element) {
    const { top, right, bottom, left } = element.getBoundingClientRect();
    return {
        top,
        right,
        bottom,
        left,
        width: right - left,
        height: bottom - top,
    };
}
export function containsNode(parent, child) {
    return parent === child || (parent.contains && parent.contains(child));
}
export const browser = typeof window !== 'undefined' && window.document && window.document.createElement;
export function getElementPseudoContent(el, selector = 'before') {
    return window.getComputedStyle(el, `:${selector}`).content.replace(/"|'/g, '');
}
export function getScrollWidth() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.position = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
//# sourceMappingURL=dom.js.map